export function managedImg(file) {
  return require(`@/assets/${file}`)
}
